export const CPCOM_STATE_STORE = "CPCOM_STATE_STORE";
